import { useMemo } from "react";
import { useFetchPostV2 } from "hooks/fetch/useFetchPostV2";
import { CaseFromAlertResponse } from "interfaces/alert";

export interface PostAppendAlertToCaseResponse {
  loading: boolean;
  error: boolean;
  postAppendToCaseCallback(): Promise<CaseFromAlertResponse>;
}

interface AppendPostResponse {
  loading: boolean;
  error: boolean;
  postCallback(): Promise<CaseFromAlertResponse>;
}

/**
 * A hook for appending alert info onto an existing case as a diagnostic report event .
 * @param alertId the id of the alert to append
 */
export const usePostAppendToCase = (
  alertId: number
): PostAppendAlertToCaseResponse => {
  const url = useMemo(() => `alerts/${alertId}/append_to_case/`, [alertId]);

  const { loading, error, postCallback }: AppendPostResponse = useFetchPostV2(
    url
  );

  return { loading, error, postAppendToCaseCallback: postCallback };
};
